export default __webpack_public_path__ + "static/media/signIn.65d1bd64.png";